import Vue from 'vue';
import { mapGetters } from 'vuex';
import * as _ from 'lodash';
import Swal from 'sweetalert2';
import Toolbar from '@/components/toolbar';
import api from '@/utils/api';
import SlSteppers from '@/components/service-log/form/service-log-form/service-log-form.vue';
import StudentCard from '@/components/service-log/form/student-card/student-card.vue';
import BottomNav from '@/components/bottom-nav';
import utilityFunctions from '@/utils/functions';
import StudentClass from '@/utils/student-class';
import ServiceLogClass from '@/utils/service-log-class';
import LoadingComponent from '@/components/loading-component';
import * as Constants from '@/constants';

export default {
  components: {
    SlSteppers,
    Toolbar,
    StudentCard,
    BottomNav,
    LoadingComponent
  },
  name: 'SlCopy',
  data() {
    return {
      showLoading: false,
      submissionData: null,
      student: null,
      loadData: false,
      medicaidArray: null,
      needLevelArray: null,
      deliveryModeArray: null,
      submitted: false
    };
  },
  computed: {
    ...mapGetters({
      showTooltip: 'showTooltip'
    }),
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  methods: {
    hasServiceInformationChanged() {
      return !_.isEqual(Vue.prototype.$savedData.serviceInformation, this.student.form.serviceInformation);
    },
    hasMedicaidInformationChanged() {
      return !_.isEqual(Vue.prototype.$savedData.medicaid, this.student.form.medicaid);
    },
    hasInformationChanged() {
      return this.hasServiceInformationChanged() || this.hasMedicaidInformationChanged() ||
        Vue.prototype.$savedData.notes !== this.student.form.notes;
    }
  },
  created() {
    utilityFunctions.clearSubmissionArray();
    const sessionId = this.$route.params.sessionId;
    this.showLoading = true;
    let data;
    Promise.all([
      api.get(Constants.NSL_GET_NURSING_SESSION_URL(sessionId)),
      api.get(Constants.GET_MEDICAID_PROCEDURES_LIST_URL()),
      api.get(Constants.NEED_LEVELS_URL()),
      api.get(Constants.DELIVERY_MODES_URL())
    ])
      .then((submission) => {
        data = submission[0].data.data;
        // set medicaid procedures array
        this.medicaidArray = submission[1].data.data;
        // set needLevelArray
        this.needLevelArray = submission[2].data.data;
        // set deliveryModeArray
        this.deliveryModeArray = submission[3].data.data;
        return api.get(Constants.GET_SERVICE_LOCATIONS_URL(data.locationName));
      })
      .then((school) => {
        data.location = school.data.data[0];
        // need to use vue.set to make the information reactive
        Vue.set(this, 'student', new StudentClass(data));
        const info = new ServiceLogClass(data, false);
        // save initialized form data to check if data changed before navigating away
        Vue.prototype.$savedData = _.cloneDeep(info);
        // need to use vue.set to make the information reactive
        Vue.set(this.student, 'form', info);
      })
      .finally(() => {
        this.loadData = true;
        this.showLoading = false;
      });
  },
  beforeRouteLeave(to, from, next) {
    if (!this.submitted) {
      if (this.hasInformationChanged()) {
        Swal.fire(
          {
            type: 'warning',
            text: 'You have unsaved information.  Are you sure you want to leave this page?',
            showCancelButton: true
          })
          .then((response) => {
            // if ok was clicked
            if (response && response.value) {
              next();
            }
          });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/form/copy-service-log/copy-service-log.js